import { CheckCircle2, AlertTriangle } from "lucide-react";
import { formatMoney, sumDecimals } from "@/lib/format";

export default function YearByYearTable({ s }) {
  const ds = s.directors;
  const allOk = ds.every((d) => d.check_ok);
  return (
    <div className="space-y-3">
      <div className="border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm" data-testid="settlement-yearly-table">
          <thead>
            <tr className="text-right text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
              <th className="px-4 py-3 text-left font-medium">FY</th>
              <th className="px-4 py-3 font-medium">FY net</th>
              <th className="px-4 py-3 font-medium">Share each</th>
              {ds.map((d) => <th key={d.id} className="px-4 py-3 font-medium">{d.name}</th>)}
            </tr>
          </thead>
          <tbody>
            {s.years.map((y, i) => (
              <tr key={y.fy} className="border-b border-border" data-testid={`settlement-year-${y.fy}`}>
                <td className="px-4 py-2.5 font-mono">{y.fy}</td>
                <td className="px-4 py-2.5 text-right font-mono">{formatMoney(y.net)}</td>
                <td className="px-4 py-2.5 text-right font-mono text-muted-foreground">{formatMoney(ds[0]?.years[i].share)}</td>
                {ds.map((d) => <td key={d.id} className="px-4 py-2.5 text-right font-mono" data-testid={`settlement-year-${y.fy}-${d.name.toLowerCase()}`}>{formatMoney(d.years[i].value)}</td>)}
              </tr>
            ))}
            <tr className="border-b border-border font-semibold">
              <td className="px-4 py-2.5" colSpan={3}>Sum (before adjustments)</td>
              {ds.map((d) => <td key={d.id} className="px-4 py-2.5 text-right font-mono" data-testid={`settlement-years-sum-${d.name.toLowerCase()}`}>{formatMoney(d.years_sum)}</td>)}
            </tr>
            <tr className="border-b border-border">
              <td className="px-4 py-2.5 text-muted-foreground" colSpan={3}>Adjustments</td>
              {ds.map((d) => <td key={d.id} className="px-4 py-2.5 text-right font-mono">{formatMoney(d.adjustment)}</td>)}
            </tr>
            {ds.some((d) => d.extras.length > 0) && (
              <tr className="border-b border-border">
                <td className="px-4 py-2.5 text-muted-foreground" colSpan={3}>Ticked-in misc &amp; memos</td>
                {ds.map((d) => <td key={d.id} className="px-4 py-2.5 text-right font-mono" data-testid={`settlement-yearly-extra-${d.name.toLowerCase()}`}>{formatMoney(d.extra)}</td>)}
              </tr>
            )}
            <tr className="font-semibold">
              <td className="px-4 py-3" colSpan={3}>Total (matches All years)</td>
              {ds.map((d) => <td key={d.id} className="px-4 py-3 text-right font-mono" data-testid={`settlement-yearly-total-${d.name.toLowerCase()}`}>{formatMoney(sumDecimals([d.years_sum, d.adjustment, d.extra]))}</td>)}
            </tr>
          </tbody>
        </table>
      </div>
      <div data-testid="settlement-yearly-check" className={`flex items-center gap-2 text-xs ${allOk ? "text-emerald-300" : "text-amber-300"}`}>
        {allOk ? <CheckCircle2 className="h-4 w-4" /> : <AlertTriangle className="h-4 w-4" />}
        {allOk ? "Year-by-year totals plus adjustments and ticked-in items equal the All years result for every director." : "Year-by-year totals don't match the All years result."}
      </div>
    </div>
  );
}
